/**
 * Create a new object by selecting only some keys
 */
export const pick =
  <TPickedKeys extends keyof any>(
    keys: readonly TPickedKeys[] | Set<TPickedKeys>,
  ) =>
  <T extends { [key in TPickedKeys]?: unknown }>(
    // without wrapping to array trick, PickedKeys containing entries not present in keyof T
    // would pass too if there is at least some overlap of keyof T and PickedKeys
    obj: [TPickedKeys] extends [keyof T] ? T : never,
  ): Pick<T, TPickedKeys> =>
    (Array.isArray(keys) ? keys : Array.from(keys)).reduce<
      Pick<T, TPickedKeys>
    >(
      (acc, key: TPickedKeys) => {
        if (key in obj) {
          acc[key] = obj[key];
        }
        return acc;
      },
      {} as Pick<T, TPickedKeys>,
    );
